export const MAX_WIDTH = 1728;
export const DATA_REPO_LINK = `https://github.com/Data-Provenance-Initiative/Data-Provenance-Collection`;
export const PAPER_LINK1 = `https://arxiv.org/pdf/2310.16787`;
export const PAPER_LINK2 = `/Consent_in_Crisis.pdf`;
export const ECONOMIES_PAPER_LINK = `/economies-of-open-intelligence.pdf`;
export const OPEN_MODEL_DASHBOARD_LINK = `https://huggingface.co/spaces/economies-open-ai/open-model-evolution`;
export const OPEN_MODEL_DATASET_LINK = `https://huggingface.co/datasets/mmpr/open_model_evolution_data`;
export const AI_OBSERVATORY_PAPER_LINK = `/ai_observatory.pdf`;
export const AI_OBSERVATORY_LINK = `https://www.ai-observatory.org/`;
export const GITHUB_ORG_LINK = `https://github.com/Data-Provenance-Initiative`;
export const CONTACT_EMAIL = `data.provenance.init@gmail.com`;
